'use client';

import { Suspense, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { captureFirstTouch } from '@/lib/acquisition';

// Records first-touch attribution (utm_*, referrer, landing path) once per browser, so the
// sign-up can attach it to the new account. Mounted in the root layout in EVERY environment —
// unlike <GoogleAnalytics/>, which is production-only — and works when GA is blocked.
function Capture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useEffect(() => { captureFirstTouch(); }, [pathname, searchParams]);
  return null;
}

export default function FirstTouchCapture() {
  return (
    <Suspense fallback={null}>
      <Capture />
    </Suspense>
  );
}
